import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Dashboard from "./dashboardmain";
import TabContainer from "./tabs";
import ListOfInvestorsTabs from "./listofInvestorTabs";
import SipSummaryTabContainer from "./SipSummaryTabContainer";

export default class DashboardRouter extends Component {
  render() {
    const { history, location } = this.props;
    return (
      <Switch location={location} history={history}>
        <Route
          path={`/dashboard/transaction-summary`}
          component={TabContainer}
        />
        <Route
          path={`/dashboard/investorType`}
          component={ListOfInvestorsTabs}
        />
        <Route
          path={`/dashboard/SipSummaryTypes`}
          component={SipSummaryTabContainer}
        />
        <Route path={`/dashboard`} exact component={Dashboard} />

        {/* <Route path="/" exact>
          <Redirect to="/dashboard" />
        </Route> */}
      </Switch>
    );
  }
}
